export const auth = {
  welcome: {
    /**
     * Zwei kurze Sätze, keine Broschüre. Wer hier landet, ist entweder ein Kind
     * mit einem Klassencode in der Hand oder jemand, der zurückkommt.
     */
    what: "Deine Wörter kommen von deiner Lehrperson, oder du tippst sie selber ab.",
    how: "Eine Runde sind zehn Wörter. Das dauert ein paar Minuten.",
    hasClassCode: "Ich habe einen Klassencode",
    practiceAlone: "Alleine üben",
    alreadyHaveAccount: "Ich habe schon ein Konto",
    newHere: "Zum ersten Mal hier?",
    footer: "Gratis, ohne Werbung, ohne E-Mail-Adresse.",
  },
  layout: {
    blurb: "Liste eintippen oder abfotografieren, zehn Wörter üben, fertig. Gratis und ohne Werbung.",
    privacy: "Keine E-Mail, kein echter Name.",
  },
  register: {
    titleJoin: "Klasse beitreten",
    titleSolo: "Konto anlegen",
    introJoin: "Den Klassencode von der Lehrperson. Dann PIN.",
    introSolo: "Kein echter Name. Eine PIN mit sechs Ziffern.",
    classCode: "Klassencode",
    classCodeHint: "Den Code sagt dir deine Lehrperson.",
    yourName: "Dein Name",
    nameHint: "Das ist dein Name hier. Damit meldest du dich an.",
    rerollAria: "Anderen Namen würfeln",
    pin: "PIN (6 Ziffern)",
    pinAgain: "PIN nochmals",
    submit: "Los gehts",
  },
  login: {
    title: "Anmelden",
    intro: "Dein Name und deine PIN.",
    yourName: "Dein Name",
    pin: "PIN",
    submit: "Anmelden",
    forgotPin: "PIN vergessen?",
    teacherCode: "Ich habe einen Code von der Lehrperson",
    noAccount: "Noch kein Konto? Alleine üben",
  },
  recovery: {
    title: "Schreib das auf",
    intro: "Wenn du deine PIN vergisst, brauchst du diesen Code. Wir zeigen ihn nur jetzt.",
    saveFile: "Als Datei speichern",
    copyFailed: "Kopieren hat nicht geklappt. Schreib den Code ab oder speicher die Datei.",
    confirm: "Ich habs aufgeschrieben",
    fileHeading: "VociFuchs — dein Code",
    fileName: (name: string) => `Name: ${name}`,
    fileCode: (code: string) => `Code: ${code}`,
    fileBody: "Diesen Code brauchst du, wenn du eine neue PIN setzt.",
    fileOnce: "Wir zeigen ihn nur einmal. Bewahr ihn gut auf.",
  },
  pinForgot: {
    title: "Neue PIN",
    introRecover: "Den Code, den du beim Anlegen aufgeschrieben hast. Dann eine neue PIN.",
    introReset: "Den Code von der Lehrperson. Dann eine neue PIN.",
    yourCode: "Dein Code",
    teacherCode: "Code von der Lehrperson",
    yourName: "Dein Name",
    newPin: "Neue PIN",
    pinAgain: "PIN nochmals",
    save: "PIN speichern",
    backToLogin: "Zurück zur Anmeldung",
    /** Under «Der Code stimmt nicht.»: the code may belong to the other form (issue #123). */
    tryReset: "Hast du den Code von der Lehrperson? Dann gib ihn hier ein.",
    loadFile: "Datei laden",
    loadFileHint: "Hast du beim Anlegen die Datei «vocifuchs-code.txt» gespeichert? Dann such sie hier.",
    notCodeFile: "In dieser Datei steht kein Code. Nimm die Datei «vocifuchs-code.txt».",
    tryRecover: "Ist es der Code, den du beim Anlegen aufgeschrieben hast? Dann gib ihn hier ein.",
  },
  code: {
    strays: (chars: string) =>
      `«${chars.split("").join(" ")}» kommt in keinem Code vor. Es gibt kein O, kein I, keine 0 und keine 1.`,
  },
  me: {
    loginHint: "So meldest du dich an.",
    /** Label under a big number on «Ich»: the number itself is shown separately. */
    sitting: (n: number) => (n === 1 ? "Wort sitzt" : "Wörter sitzen"),
    dueToday: "heute dran",
    dueTodayAria: (n: number) => `${n} Wörter heute dran, jetzt üben`,
    streak: (n: number) => (n === 1 ? "Tag in Folge" : "Tage in Folge"),
    lists: (n: number) => (n === 1 ? "Liste" : "Listen"),
    /** Entry to «Wiederholen» (issue #101); the archive has the same one. */
    review: "Mehrere Listen wiederholen",
    class: "Klasse",
    noClass: "Du bist in keiner Klasse.",
    createClass: "Klasse anlegen",
    joinClass: "Klasse beitreten",
    haveInvite: "Ich habe eine Einladung",
    leaveClass: "Klasse verlassen",
    leaveConfirm: (name: string) =>
      `Die Klasse «${name}» wirklich verlassen? Deine Wörter und dein Lernstand bleiben dir. Listen, die du geteilt hast, gehören danach wieder nur dir.`,
    account: "Konto",
    logout: "Abmelden",
    delete: "Konto löschen",
    deleteConfirm: "Konto wirklich löschen? Dein Lernstand ist dann weg.",
  },
  join: {
    /** Issue #42: the name before the membership counts. */
    preview: (name: string) => `Du trittst der Klasse «${name}» bei.`,
    title: "Klasse beitreten",
    intro: "Den Code sagt dir deine Lehrperson.",
    classCode: "Klassencode",
    submit: "Beitreten",
  },
  class: {
    createTitle: "Klasse anlegen",
    createIntro: "Zum Beispiel 5b Voci. Kein Schulname, kein Ort.",
    className: "Klassenname",
    /**
     * Families use classes too. The obvious family name carries a surname,
     * which PLAN.md §3 keeps out; say so before it is typed.
     */
    classNameHint: "Auch für zu Hause: eine Familie kann eine Klasse sein. Nimm keinen echten Namen, zum Beispiel «Voci-Crew».",
    inviteCode: "Einladungscode",
    inviteHint: "Den Code bekommst du von einer Lehrperson.",
    createSubmit: "Klasse anlegen",
    classCode: "Klassencode",
    rotateCode: "Neuen Code machen",
    /** Issue #48: invite by link or QR code instead of eight characters from the board. */
    shareLink: "Link zum Beitreten",
    copyLink: "Link kopieren",
    linkCopied: "Link kopiert",
    showQr: "QR-Code zeigen",
    hideQr: "QR-Code schliessen",
    qrHint: "Mit der Kamera scannen. Der Klassencode ist dann schon eingetragen.",
    qrAria: (name: string) => `QR-Code zum Beitritt in die Klasse ${name}`,
    rotateHint: "Ein neuer Code macht alte Links und QR-Codes ungültig.",
    /** Issue #41: sharing and handing over the lead. */
    leadTitle: "Klassenleitung",
    leadIntro: "Eine zweite Leitung kann PINs zurücksetzen und die Klasse übernehmen, zum Beispiel wenn die Lehrperson wechselt.",
    leadInvite: "Einladungscode für eine zweite Leitung",
    leadInviteLabel: "Einladungscode für die Mitleitung",
    leaveAsLead: "Klasse verlassen",
    leaveAsLeadConfirm: (name: string) => `Die Klasse «${name}» verlassen? Die andere Leitung führt sie weiter.`,
    closeClass: "Klasse schliessen",
    closeClassConfirm: (name: string) =>
      `Die Klasse «${name}» schliessen? Der Klassencode gilt danach nicht mehr.`,
    coLeadTitle: "Eine Klasse mitleiten",
    coLeadIntro: "Du hast einen Einladungscode von einer Klassenleitung bekommen.",
    coLeadSubmit: "Mitleiten",
    inviteForTeacher: "Einladungscode für eine Lehrperson",
    showOnce: "Wir zeigen ihn nur jetzt. Schreib ihn auf.",
    members: "Mitglieder",
    leadership: "Klassenleitung",
    resetPin: "PIN zurücksetzen",
    resetPinLabel: (name: string) => `Neuer PIN-Code für ${name}`,
    remove: "Aus der Klasse nehmen",
    removeConfirm: (name: string) => `${name} aus der Klasse nehmen?`,
    anotherClass: "Weitere Klasse",
    anotherClassHint: "Damit eine andere Lehrperson eine eigene Klasse anlegen kann.",
    createInvite: "Einladungscode erzeugen",
  },
} as const;
